import React, { useState } from 'react';
import classes from './index.module.scss';
import TextInput from '../../UI/TextInput';
import { ReactComponent as SearchIcon } from '../../../assets/icons/search-input-icon.svg';
import { HashLink } from 'react-router-hash-link';
import { Container, Col, Row } from 'react-bootstrap';
import qs from 'query-string';
import { Link } from 'react-router-dom';

const SearchOpportunities = () => {
  const [bannerSearchValue, setBannerSearchValue] = useState("");

  const queryParams = {
    entity: 'contract_opportunities',
    search: bannerSearchValue,
  }

  const onChangeSearchHandler = event => {
    setBannerSearchValue(event.target.value);
  }

  return (
    <section className={classes.Search_Opportunities}>
      <Container>
        <Row>
          <Col>
            <div>
              <h2 className={classes.Search_Opportunities_Title}>
                Search for Opportunities 
              </h2>
              <p className={classes.Search_Opportunities_Sub_Title}>
                No login is required to search for opportunities<br/>
                In order to <b>match</b> opportunities, you must{" "} 
                <HashLink
                  to="/#basic-info"
                  smooth
                >
                  <b>
                    register on MatchForce
                  </b>
                </HashLink>
              </p>
            </div>
            <div className={classes.FullTextSearch}>
              <div className={classes.Search_Input_Wrapper}>
                <div className={classes.Search_Input}>
                  <TextInput
                    name="search"
                    type="text"
                    id="search"
                    placeholder="Keyword or Solicitation Number"
                    onChange={onChangeSearchHandler}
                  />
                  <SearchIcon />
                </div>
              </div>
              <Link
                className='btnSizes filledBtn px-5 ml-2 d-flex align-items-center'
                to={`/search?${qs.stringify(queryParams)}`}
              >
                Search
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default SearchOpportunities;